var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, Utils, CustomElement, Watch, ViewChild, PropertyConverters, Components, Defaults } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
let PacemMarqueeElement = class PacemMarqueeElement extends Components.PacemElement {
    constructor() {
        super(...arguments);
        this._state = { overlap: 0, content: 0 };
    }
    // TODO: reuse css animation injection
    connectedCallback() {
        super.connectedCallback();
        const css = this._css = document.createElement('style');
        document.head.appendChild(css);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'speed') {
            this._adjust();
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._adjust();
    }
    disconnectedCallback() {
        if (!Utils.isNull(this._css))
            this._css.remove();
        super.disconnectedCallback();
    }
    _overlapResize(evt) {
        this._state.overlap = evt.detail.width;
        this._adjust();
    }
    _contentResize(evt) {
        this._state.content = evt.detail.width;
        this._adjust();
    }
    _adjust() {
        const state = this._state;
        if (state.content > 0 && state.overlap > 0) {
            const m = this._marquee;
            const id = 'marquee-' + Utils.uniqueCode(), // rename the animation every time (Edge bug)
            from = Math.round(state.overlap), to = -Math.round(state.content);
            this._css.innerHTML = `@keyframes ${id} {
    0% {
        transform: translateX(${from}px);
    }

    100% {
        transform: translateX(${to}px);
    }
}`;
            const speed = this.speed || 20;
            const time = Math.max(speed, Math.round(speed * Math.abs(from - to) / 1920));
            m.style.animationName = id;
            m.style.animationDuration = time + 's';
            m.style.animationIterationCount = 'infinite';
            m.style.animationTimingFunction = 'linear';
        }
    }
};
__decorate([
    ViewChild(`.${PCSS}-marquee`)
], PacemMarqueeElement.prototype, "_marquee", void 0);
__decorate([
    ViewChild(`.${PCSS}-marquee-overlap`)
], PacemMarqueeElement.prototype, "_overlap", void 0);
__decorate([
    ViewChild(P + "-resize")
], PacemMarqueeElement.prototype, "_resizer", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemMarqueeElement.prototype, "speed", void 0);
PacemMarqueeElement = __decorate([
    CustomElement({
        tagName: P + '-marquee', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<div class="${PCSS}-marquee"><${P}-content></${P}-content></div><div class="${PCSS}-marquee-overlap"></div>
<${P}-resize target="{{ :host._overlap }}" on-${Components.ResizeEventName}=":host._overlapResize($event)"></${P}-resize>
<${P}-resize target="{{ :host._marquee }}" on-${Components.ResizeEventName}=":host._contentResize($event)"></${P}-resize>`
    })
], PacemMarqueeElement);
export { PacemMarqueeElement };
